// extracted by mini-css-extract-plugin
export default {"planItem":"OQo0m9","errorTooltip":"hM6ULe"};